import React from "react";
import Profile from "../../components/Profile";

const ProfilePage = () => {
  return (
    <>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4 mx-3">
        <div className="d-block mb-4 mb-xl-0">
          <h4>Profile</h4>
        </div>
      </div>
      <Profile />
    </>
  );
};

export default ProfilePage;
